<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>

<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<div class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">Mis Plantillas de Impresión</h4>
							</div>
							<div class="card-content">
								<div class="card-body">
									<ngx-datatable
										#tableRef
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi">
										<ngx-datatable-column name="nombreTipoDte" [flexGrow]="4" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Tipo de Documento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row">
												<span class="text-table-alignment">
													<span class="badge badge-secondary mr-1">{{ row.codigoTipoDte }}</span>
													{{ row.nombreTipoDte }}
												</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="tipoPapel" [flexGrow]="2.5" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Papel</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row">
												<ng-select
													[items]="row.tiposPapel"
													[(ngModel)]="row.papelSeleccionado"
													[clearable]="false"
													(change)="onPapelChange(row)"
													appendTo="body"
													style="min-width: 130px;">
												</ng-select>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="plantilla" [flexGrow]="5" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Plantilla</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row">
												<ng-select
													[items]="row.opcionesFiltradas"
													bindLabel="label"
													[(ngModel)]="row.seleccionada"
													[clearable]="false"
													(change)="onSeleccionChange(row)"
													appendTo="body"
													style="min-width: 240px;">
													<ng-template ng-label-tmp let-item="item">
														<span>{{ item.plantilla.descripcion }}</span>
														<span *ngIf="item.isDefault" class="text-muted ml-1">(defecto)</span>
														<span *ngIf="item.asignada" class="text-success ml-1">(asignada)</span>
													</ng-template>
													<ng-template ng-option-tmp let-item="item">
														<span class="badge badge-pill mr-1" [ngClass]="getEtiquetaBadgeClass(item.label)">{{ item.label }}</span>
														<span>{{ item.plantilla.descripcion }}</span>
														<span *ngIf="item.isDefault" class="text-muted small ml-1">(defecto)</span>
														<span *ngIf="item.asignada" class="text-success small ml-1">(asignada)</span>
													</ng-template>
												</ng-select>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="2.5" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a class="primary edit mr-1 mrless"
												   ngbTooltip= "{{ !puedeAsignar(row) ? 'No se puede asignar una plantilla ya asignada' : 'Asignar plantilla' }}"
												   id="mantenedor-plantillas-usuario.component_Asignar"
												   [class.disabled]="!puedeAsignar(row)"
												   [style.opacity]="puedeAsignar(row) ? '1' : '0.5'"
												   (click)="puedeAsignar(row) && asignarPlantilla(row)">
													<div class="icon-circle bg-success text-center align-middle pt-info-button">
														<fa-icon icon="check" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

												<a class="primary edit mr-1 mrless"
												   ngbTooltip="Vista previa"
												   id="mantenedor-plantillas-usuario.component_Vista_Previa"
												   (click)="previsualizarPlantilla(row)">
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

											<a *ngIf="!row.seleccionada?.isDefault"
												   class="primary edit mr-1 mrless"
												   ngbTooltip="Editar nombre"
												   id="mantenedor-plantillas-usuario.component_Editar"
												   (click)="abrirEditarModal(row, editModal)">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

											<a *ngIf="!row.seleccionada?.isDefault"
												   class="primary edit mr-1 mrless"
												   ngbTooltip="Desasignar plantilla"
												   id="mantenedor-plantillas-usuario.component_Desasignar"
												   [swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de desasignar la plantilla ' + row.seleccionada?.plantilla?.descripcion + ' de su empresa?',
														confirmButtonText: 'Desasignar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
												   (confirm)="eliminarPlantilla(row)">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableRef.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="120"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">

										<ngx-datatable-column name="documento" [flexGrow]="6" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span>Documento / Plantilla</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="mb-1">
													<span class="badge badge-secondary mr-1">{{ row.codigoTipoDte }}</span>
													<strong>{{ row.nombreTipoDte }}</strong>
												</div>
												<ng-select
													[items]="row.tiposPapel"
													[(ngModel)]="row.papelSeleccionado"
													[clearable]="false"
													(change)="onPapelChange(row)"
													appendTo="body"
													class="mb-1">
												</ng-select>
												<ng-select
													[items]="row.opcionesFiltradas"
													bindLabel="label"
													[(ngModel)]="row.seleccionada"
													[clearable]="false"
													(change)="onSeleccionChange(row)"
													appendTo="body">
													<ng-template ng-label-tmp let-item="item">
														<span class="badge badge-pill mr-1" [ngClass]="getEtiquetaBadgeClass(item.label)">{{ item.label }}</span>
														<span>{{ item.plantilla.descripcion }}</span>
														<span *ngIf="item.asignada" class="text-success ml-1">(asignada)</span>
													</ng-template>
													<ng-template ng-option-tmp let-item="item">
														<span class="badge badge-pill mr-1" [ngClass]="getEtiquetaBadgeClass(item.label)">{{ item.label }}</span>
														<span>{{ item.plantilla.descripcion }}</span>
														<span *ngIf="item.isDefault" class="text-muted small ml-1">(defecto)</span>
														<span *ngIf="item.asignada" class="text-success small ml-1">(asignada)</span>
													</ng-template>
												</ng-select>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a class="primary edit mr-1 mrless"
												   ngbTooltip="Asignar plantilla"
												   id="mantenedor-plantillas-usuario.component_Asignar_Mobile"
												   [class.disabled]="!puedeAsignar(row)"
												   [style.pointer-events]="puedeAsignar(row) ? 'auto' : 'none'"
												   [style.opacity]="puedeAsignar(row) ? '1' : '0.5'"
												   (click)="puedeAsignar(row) && asignarPlantilla(row)">
													<div class="icon-circle bg-success text-center align-middle pt-info-button">
														<fa-icon icon="check" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a class="primary edit mr-1 mrless" ngbTooltip="Vista previa" id="mantenedor-plantillas-usuario.component_Vista_Previa_Mobile" (click)="previsualizarPlantilla(row)">
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a *ngIf="!row.seleccionada?.isDefault" class="primary edit mr-1 mrless" ngbTooltip="Editar" id="mantenedor-plantillas-usuario.component_Editar_Mobile" (click)="abrirEditarModal(row, editModal)">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a *ngIf="!row.seleccionada?.isDefault"
												   class="primary edit mr-1 mrless"
												   ngbTooltip="Desasignar"
												   id="mantenedor-plantillas-usuario.component_Desasignar_Mobile"
												   [swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de desasignar esta plantilla?',
														confirmButtonText: 'Desasignar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
												   (confirm)="eliminarPlantilla(row)">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #editModal let-modal>
	<div class="modal-header">
		<div class="modal-wizard-label">
			<div class="modal-wizard-title">Editar nombre de plantilla</div>
			<div class="modal-wizard-desc">Solo disponible para plantillas personalizadas</div>
		</div>
	</div>
	<div class="modal-body">
		<div class="form-group">
			<label for="nuevoNombre">Nuevo nombre</label>
			<input
				id="nuevoNombre"
				type="text"
				class="form-control"
				[(ngModel)]="nuevoNombre"
				maxlength="200"
				placeholder="Ingrese el nuevo nombre..."
				autofocus />
			<small class="form-text text-muted">Actualmente: <strong>{{ plantillaEditando?.descripcion }}</strong></small>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="cancelarEdicion()">Cancelar</button>
		<button type="button" class="btn btn-success" (click)="guardarNombre()" [disabled]="!nuevoNombre.trim()">Guardar</button>
	</div>
</ng-template>

